<script lang="ts" setup>
import { inject, computed } from 'vue'
import type { PropType } from 'vue'
import BsNavDropdownItem from '@/legacy/components/NavDropdownItem.vue'
import type { HeaderProvideData } from '@/legacy/ts/header'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName } from '@/lib/utils'
import type { ImenuListItem } from '@/types/Menu'

const headerProvideData = inject<HeaderProvideData>('headerProvideData')
const setCurrentMobileNavSubmenu = inject<Function>(
	'setCurrentMobileNavSubmenu',
)
const props = defineProps({
	menuList: {
		type: Array as PropType<ImenuListItem[]>,
		required: true,
	},
	menuListMember: {
		type: Array as PropType<ImenuListItem[]>,
		required: true,
	},
	newBadgeText: {
		type: String,
		default: '',
	},
})

const subMenuList = computed(() => {
	if (!props.menuList) return []
	return props.menuList.filter(item => item.children && item.children.length)
})

const currentMenuList = computed(() => {
	if (headerProvideData?.currentMobileNavTab === 'member') {
		return props.menuListMember
	}
	return props.menuList
})

function handleClick(menu: ImenuListItem) {
	if (menu.gaButtonName) {
		sendGaEvent(menu.gaButtonName)
	}
	if (menu.action) {
		menu.action()
		return
	}
	if (!menu.category) return
	if (setCurrentMobileNavSubmenu) {
		setCurrentMobileNavSubmenu(menu.category)
	}
}

function sendGaEvent(buttonName = '') {
	if (buttonName) {
		createGAEvent(GaGeneralEvent.ButtonClick, {
			button_name: buttonName,
			page_name: getCurrentGaPageName(),
		})
	}
}
</script>

<template>
	<div class="bs-sliding-menu">
		<nav>
			<ul class="bs-sliding-menu__first-layer">
				<li
					v-for="menu in currentMenuList"
					class="bs-sliding-menu__first-layer__item"
					:key="menu.category"
				>
					<a
						v-if="menu.link"
						class="bs-sliding-menu__first-layer__item__link"
						:href="menu.link"
						@click="sendGaEvent(menu.gaButtonName)"
					>
						{{ menu.name }}
					</a>
					<a
						v-else
						class="bs-sliding-menu__first-layer__item__link"
						href="javascript:void(0)"
						@click="handleClick(menu)"
					>
						{{ menu.name }}
						<i
							:class="`bs-sliding-menu__icon--${menu.icon}`"
							v-if="menu.icon"
						></i>
						<i class="bs-sliding-menu__icon--arrow-right" v-else></i>
					</a>
				</li>
			</ul>
		</nav>
		<aside class="bs-sliding-menu__second-layer">
			<nav
				:class="[
					'bs-sliding-menu__second-layer__panel',
					{
						active:
							headerProvideData?.currentMobileNavSubmenu === menu.category,
					},
				]"
				v-for="menu in subMenuList"
				:key="menu.category"
			>
				<div class="bs-sliding-menu__second-layer__panel__container">
					<div class="bs-sliding-menu__second-layer__panel__title">
						{{ menu.name }}
					</div>
					<ul class="bs-sliding-menu__second-layer__panel__list">
						<BsNavDropdownItem
							v-for="subMenu in menu.children"
							:key="subMenu.name"
							:link="subMenu.link"
							:icon="subMenu.icon"
							:name="subMenu.name"
							:desc="subMenu.desc"
							:isNewBadge="subMenu.isNewBadge"
							:newBadgeText="newBadgeText"
							:parentName="menu.name"
						></BsNavDropdownItem>
					</ul>
				</div>
			</nav>
		</aside>
	</div>
</template>
